
import { useCallback } from "react";

interface UseFormatConversionProps {
  isLegacyFormat: boolean;
  setIsLegacyFormat: (value: boolean) => void;
  setHasChanges: (value: boolean) => void;
  saveContent: (...args: any[]) => Promise<void>;
}

export function useFormatConversion({
  isLegacyFormat,
  setIsLegacyFormat,
  setHasChanges,
  saveContent,
}: UseFormatConversionProps) {

  const convertToModernFormat = useCallback(() => {
    if (!isLegacyFormat) {
      console.log("Already using modern format");
      return;
    }
    
    console.log("Converting to modern format");
    setIsLegacyFormat(false);
    setHasChanges(true);
    
    // Save the content with the new format
    saveContent();
  }, [isLegacyFormat, setIsLegacyFormat, setHasChanges, saveContent]);

  return {
    convertToModernFormat,
  };
}
